'use client'

import Image from 'next/image'
import Link from 'next/link'
import { Jost } from 'next/font/google'
import { useState, useRef, useEffect } from 'react'

const jost = Jost({
  subsets: ['latin'],
  weight: ['500'], // Choose the weights you need
  variable: '--font-jost',
})

export default function Navigation() {
  const [display, setDisplay] = useState(false)
  const [showDropdownMobile, setShowDropdownMobile] = useState(false)
  const [showDropdownDesktop, setShowDropdownDesktop] = useState(false)
  const dropdownRefMobile = useRef<HTMLDivElement>(null)
  const dropdownRefDesktop = useRef<HTMLDivElement>(null)

  function handleDisplay() {
    setDisplay(!display)
  }

  function toggleDropdownMobile() {
    setShowDropdownMobile(!showDropdownMobile)
  }

  function toggleDropdownDesktop() {
    setShowDropdownDesktop(!showDropdownDesktop)
  }

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRefMobile.current && !dropdownRefMobile.current.contains(event.target as Node)) {
        setShowDropdownMobile(false)
      }
      if (dropdownRefDesktop.current && !dropdownRefDesktop.current.contains(event.target as Node)) {
        setShowDropdownDesktop(false)
      }
    }

    if (showDropdownMobile || showDropdownDesktop) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [showDropdownMobile, showDropdownDesktop])

  return (
    <div
      className={`md:mx-[149px] mx-5 mt-[12px] md:flex md:justify-between bg-[#DCE7FD] ${jost.className} rounded-[12px] py-4 md:px-16 px-5 items-center`}
    >
      <div className="flex gap-x-20 md:justify-start justify-between items-center">
        <Link href="/">
          <Image src="/images/logo.png" alt="Logo of Intrn" width={96} height={20} />
        </Link>
        <Image
          src="/icons/hamburger.svg"
          alt="Hamburger Icon"
          width={72}
          height={20}
          className="w-18 h-5 cursor-pointer md:hidden"
          onClick={handleDisplay}
        />
      </div>
      <ul
        className={`text-base md:flex md:flex-row flex flex-col md:gap-x-8 md:pt-0 md:gap-y-0 text-[#525252] ${display ? 'block gap-y-8 pt-8' : 'hidden'}`}
      >
        <li>
          <a href="/school-portals">School Portals</a>
        </li>
        <li>
          <a href="https://app.intrns.com/signup/company">Companies</a>
        </li>
        <li>
          <a href="/about-us">About Us</a>
        </li>
        <div className="relative md:hidden" ref={dropdownRefMobile}>
          <button
            onClick={toggleDropdownMobile}
            className="bg-[#1E2763] py-2 px-5 rounded-[100px] text-white block w-[40%]"
          >
            LOG IN
          </button>
          {showDropdownMobile && (
            <div className="absolute top-full mt-2 left-0 bg-white rounded-lg shadow-lg py-2 w-48 z-50 border border-gray-100">
              <a
                href="https://app.intrns.com/login"
                className="block px-4 py-3 text-[#1E2763] hover:bg-[#DCE7FD] transition-colors text-sm"
              >
                Login as Siwes
              </a>
              <a
                href="https://app.intrns.com/login"
                className="block px-4 py-3 text-[#1E2763] hover:bg-[#DCE7FD] transition-colors text-sm"
              >
                Login as Graduate Intern
              </a>
              <a
                href="https://app.intrns.com/login"
                className="block px-4 py-3 text-[#1E2763] hover:bg-[#DCE7FD] transition-colors text-sm"
              >
                Login as Non-Graduate Intern
              </a>
              <a
                href="https://app.intrns.com/login"
                className="block px-4 py-3 text-[#1E2763] hover:bg-[#DCE7FD] transition-colors text-sm"
              >
                Login as Company
              </a>
            </div>
          )}
        </div>
      </ul>
      <div className="relative" ref={dropdownRefDesktop}>
        <button
          onClick={toggleDropdownDesktop}
          className="bg-[#1E2763] py-2 px-5 rounded-[100px] text-white md:block hidden"
        >
          LOG IN
        </button>
        {showDropdownDesktop && (
          <div className="absolute top-full mt-2 right-0 bg-white rounded-lg shadow-lg py-2 w-48 z-50 border border-gray-100">
            <a
              href="/school-portals"
              className="block px-4 py-3 text-[#1E2763] hover:bg-[#DCE7FD] transition-colors text-sm"
            >
              Login as Siwes
            </a>
            <a
              href="https://app.intrns.com/login"
              className="block px-4 py-3 text-[#1E2763] hover:bg-[#DCE7FD] transition-colors text-sm"
            >
              Login as Graduate Intern
            </a>
            <a
              href="https://app.intrns.com/login"
              className="block px-4 py-3 text-[#1E2763] hover:bg-[#DCE7FD] transition-colors text-sm"
            >
              Login as Non-Graduate Intern
            </a>
            <a
              href="https://app.intrns.com/login"
              className="block px-4 py-3 text-[#1E2763] hover:bg-[#DCE7FD] transition-colors text-sm"
            >
              Login as Company
            </a>
          </div>
        )}
      </div>
    </div>
  )
}
